export default "__VITE_ASSET__a04159c3__"